import { useGLTF } from '@react-three/drei'
import { useLayoutEffect, useMemo, useEffect } from 'react'
import * as THREE from 'three'
import Sticker from './Sticker'

export default function NormalizedModel({
  url,
  selectedMeshName,
  onMeshesLoaded
}) {
  const { scene } = useGLTF(url)

  const clonedScene = useMemo(() => scene.clone(true), [scene])

  // Normalize scale
  useLayoutEffect(() => {
    const box = new THREE.Box3().setFromObject(clonedScene)
    const size = box.getSize(new THREE.Vector3())
    const center = box.getCenter(new THREE.Vector3())

    const TARGET_HEIGHT = 1.85
    const scale = TARGET_HEIGHT / size.y
    clonedScene.scale.setScalar(scale)

    box.setFromObject(clonedScene)
    box.getCenter(center)
    clonedScene.position.sub(center)
  }, [clonedScene])

  // Extract mesh names
  useEffect(() => {
    const meshes = []

    clonedScene.traverse((child) => {
      if (child.isMesh) {
        meshes.push(child.name || "UnnamedMesh")
      }
    })

    onMeshesLoaded(meshes)
  }, [clonedScene, onMeshesLoaded])

  // Find selected mesh
  let targetMesh = null
  clonedScene.traverse((child) => {
    if (child.isMesh && child.name === selectedMeshName) {
      targetMesh = child
    }
  })

  return (
    <>
      <primitive object={clonedScene} />

      {targetMesh && (
        <Sticker
          mesh={targetMesh}
          position={[0, 1, 0.6]}
          rotation={[0, 0, 0]}
          scale={0.6}
          image="/stickers/logo.png"
        />
      )}
    </>
  )
}

